import {StyledFacebookMessageConfirmOrder_Thead} from './_styled'
import {useTranslation} from "react-i18next";

export const FacebookMessageConfirmOrder_Thead = ({...props}) => {
    const {t} = useTranslation()
  return (
    <StyledFacebookMessageConfirmOrder_Thead {...props}>
      <div className="facebook-message-confirm-order-thead__th">
          {t('page')}
      </div>
      <div className="facebook-message-confirm-order-thead__th">{t('status')}</div>
      <div className="facebook-message-confirm-order-thead__th">{t('facebookManament_usageStatus')}</div>
    </StyledFacebookMessageConfirmOrder_Thead>
  )
}
